import configureStore from './configureStore'
import rootReducer from './reducers/rootReducer'
import { rootSaga } from './saga/rootSaga'
import { GameState } from './types/game'
import { LogErrorState } from './types/logError'
import { NotificationState } from './types/notification'

// export const history = createBrowserHistory()

export const store = configureStore(rootReducer, rootSaga)

export type AppDispatch = typeof store.dispatch
// export type RootState = ReturnType<typeof store.getState>;
export type AppState = {
  logError: LogErrorState
  notification: NotificationState
  // todos: TodosState
  game: GameState
}
